import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete, Chip } from '@mui/material';
import ObtenerEspecialidades from '../functions/ObtenerEspecialidades';
import ObtenerPrestador from '../functions/ObtenerPrestador';
import ObtenerEspecialidadesPorPrestador from '../functions/ObtenerEspecialidadesPorPrestador';
import EspecialidadSeleccionar from '../types/EspecialidadSeleccionar';
import PrestadorSeleccionar from '../types/PrestadorSeleccionar';
import ObtenerPrestadorEspecialidades from '../functions/ObtenerPrestadorEspecialidades';

interface SeleccionarEspecialidadesProps {
    elPrestador: PrestadorSeleccionar;
    onChange: (especialidad: EspecialidadSeleccionar) => void;
    onRemove: (especialidad: EspecialidadSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarEspecialidades: React.FC<SeleccionarEspecialidadesProps> = ({ elPrestador, onChange, onRemove, onClear, eliminando }) => {

    const [prestador, setPrestador] = useState<PrestadorSeleccionar>({id: 0, prestador: '', especialidades: [], planes: []});
    const [especialidades, setEspecialidades] = useState<EspecialidadSeleccionar[]>([]);

    const fetchDatosIniciales = async () => {
        
        // Recupero los datos de las especialidades
        const dataEspecialidades = await ObtenerEspecialidades();
        if (dataEspecialidades.especialidades_ok === 'si') {

            const especialidadesRecuperadas: EspecialidadSeleccionar[] = [];
            for (const especialidad of dataEspecialidades.especialidades) {
                especialidadesRecuperadas.push({
                    id: especialidad.id,
                    especialidad: especialidad.especialidad
                });
            }

            setEspecialidades(especialidadesRecuperadas);
            
            if (elPrestador.id > 0) {
                
                setPrestador(elPrestador);
            }
        }
    };

    const onChangeLocal = (especialidad: EspecialidadSeleccionar) => {
        // Need to update the especialidades array with the new especialidad
        const especialidadesCopy = [...prestador.especialidades];
        especialidadesCopy.push(especialidad);
        setPrestador({
            ...prestador,
            especialidades: especialidadesCopy
        });
        onChange(especialidad);
    }

    const onRemoveLocal = (especialidad: EspecialidadSeleccionar) => {
        // Need to update the especialidades array removing the especialidad
        const especialidadesCopy = prestador.especialidades.filter((item) => item.id !== especialidad.id);
        setPrestador({
            ...prestador,
            especialidades: especialidadesCopy
        });
        onRemove(especialidad);
    }

    const onClearLocal = () => {
        setPrestador({
            ...prestador,
            especialidades: []
        });
        onClear();
    };

    useEffect(() => {
        fetchDatosIniciales()
    }, []);

    /*useEffect(() => {
        fetchRubros()
    }, [rubroInicial]);*/

    return (
        <div className="flex flex-col w-full">
            {/*<Autocomplete
                multiple
                options={especialidades}
                getOptionLabel={(option) => option.especialidad}
                value={prestador.especialidades}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                    onChange(newValue[0]);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Especialidades"
                        placeholder="Seleccionar especialidades"
                    />
                )}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                    <Chip
                        variant="outlined"
                        label={option.especialidad}
                        {...getTagProps({ index })}
                    />
                    ))
                }
            />*/}
            <Autocomplete
                multiple
                id="especialidades"
                size="small"
                options={especialidades}
                getOptionLabel={(option) => option.especialidad}
                value={prestador.especialidades}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue, reason, details) => {
                    if (reason === 'selectOption') {
                        if (details?.option) {
                            onChangeLocal(details.option);
                        }
                    } else if (reason === 'removeOption') {
                        if (details?.option) {
                            onRemoveLocal(details.option);
                        }
                    } else if (reason === 'clear') {
                        onClearLocal();
                        onClear();
                    }
                }}
                renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                        <Chip
                            key={key}
                            variant="filled"
                            label={option.especialidad}
                            size="small"
                            {...tagProps}
                        />
                    );
                })
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Especialidades del Prestador"
                        placeholder="Especialidades"
                    />
                )}
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarEspecialidades;